import { TransactionsDetail } from '@/components/InvoiceReportDetailDrawer/TransactionsDetail';
import { SectionHeading } from '@/features/invoice_reports/components/InvoiceReportDetailDrawer/components/SectionHeading';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

type TransactionsDetailSectionProps = {
  reportId: string;
  /** Column dataIndex values to exclude from the transactions table */
  excludeColumns?: string[];
};

export const TransactionsDetailSection: FC<TransactionsDetailSectionProps> =
  memo(({ reportId, excludeColumns }) => {
    const { t } = useTranslation();
    return (
      <SectionHeading title={t('invoice_reports.transactions.title')}>
        <TransactionsDetail
          reportId={reportId}
          excludeColumns={excludeColumns}
        />
      </SectionHeading>
    );
  });
TransactionsDetailSection.displayName = 'TransactionsDetailSection';
